import { ErrorEventEnum } from './enums';
import {
	captchaActions,
	applicationActions,
} from '../controller';

const { detectCaptchaFailedAction } = captchaActions;
const { navigateToOverPageAction } = applicationActions;
const { CAPTCHA_ERROR_OVER_LIMIT_EVENT } = ErrorEventEnum;
const getErrorCode = error => {
	return error.code || error.response?.code;
};
const handleCaptchaEpicError = (error = {}) => {
	if (getErrorCode(error) === CAPTCHA_ERROR_OVER_LIMIT_EVENT) {
		return navigateToOverPageAction;
	}

	return detectCaptchaFailedAction;
};

export {
	handleCaptchaEpicError,
};
